function SideText() {
  return (
    <div className="flex image-container justify-center max-sm:hidden">
      <div className="flex flex-col justify-end items-center">
        <div className="w-full text-white">
          <div className="font-bold text-5xl leading-[75px] pb-5">
            Digital platform <br /> for candidate verification
          </div>
          <div className="font-normal text-[35px] leading-10 pb-14">
            Start your journey now with us
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideText;
